import { z } from 'zod';
import { emailSchema, roleSchema, uuidSchema } from './common.js';
/** POST /auth/magic-link — always 200, non-enumerating (BP-01 §2.2/§4). */
export const magicLinkRequestSchema = z.object({ email: emailSchema });
/** POST /auth/magic-link/consume */
export const magicLinkConsumeSchema = z.object({ token: z.string().min(20).max(200) });
/** POST /auth/login — orgId disambiguates when the email is a member of several orgs. */
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1).max(200),
    orgId: uuidSchema.optional(),
});
/** POST /auth/totp */
export const totpSchema = z.object({ code: z.string().regex(/^\d{6}$/) });
/** POST /auth/password — set/replace password after a magic-link login. */
export const setPasswordSchema = z.object({
    newPassword: z.string().min(10).max(200),
    currentPassword: z.string().min(1).max(200).optional(),
});
/** Result discriminator returned by login/consume when a second factor is needed. */
export const authResultSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('ok') }),
    z.object({ status: z.literal('totp_required') }),
    z.object({
        status: z.literal('choose_org'),
        orgs: z.array(z.object({ id: uuidSchema, name: z.string(), role: roleSchema })),
    }),
]);
/** POST /auth/choose-org — pick the active org when a user belongs to several. */
export const chooseOrgSchema = z.object({ orgId: uuidSchema });
//# sourceMappingURL=auth.js.map